import { version } from '../../package.json';

const loadBoolEnv = (env: string | undefined): boolean => {
  try {
    return JSON.parse(env as string);
  } catch {
    return false;
  }
};

const loadNumberEnv = (env: string | undefined): number => parseInt(env as string, 10);

export const ENABLE_DEV_HELPERS = loadBoolEnv(process.env.ENABLE_DEV_HELPERS);

export const PAGINATION_LIMIT = loadNumberEnv(process.env.PAGINATION_LIMIT) || 15;

export const DEV = process.env.NODE_ENV !== 'production';
export const API_URL = process.env.API_URL;

export const HELP_EMAIL = 'info@pracanakolach.pl';

export const GOOGLE_MAPS_API_KEY =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_GOOGLE_MAPS_API_KEY) ||
  process.env.GOOGLE_MAPS_API_KEY ||
  '';
export const GOOGLE_MAP_ID =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_GOOGLE_MAP_ID) ||
  process.env.GOOGLE_MAP_ID ||
  '';

export const GOOGLE_ANALYTICS_CONTAINER =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_GOOGLE_ANALYTICS_CONTAINER) ||
  process.env.GOOGLE_ANALYTICS_CONTAINER;

export const GOOGLE_ANALYTICS_DEBUG = loadBoolEnv(process.env.GOOGLE_ANALYTICS_DEBUG);

export const GOOGLE_TAG_MANAGER_CONTAINER = process.env.GOOGLE_TAG_MANAGER_CONTAINER;

// Vite exposes only import.meta.env.VITE_* to the client; process.env is empty in build
const recaptchaKey =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_GOOGLE_RECAPTCHA_API_KEY) ||
  process.env.GOOGLE_RECAPTCHA_API_KEY ||
  '';
export const GOOGLE_RECAPTCHA_API_KEY = recaptchaKey;
export const GOOGLE_RECAPTCHA_ENABLED = !DEV && !!recaptchaKey;
export const UNSUCCESSFUL_LOGIN_TRIES_RECAPTCHA = 5;
export const UNSUCCESSFUL_LOGIN_TRIES_RECOVERY = 3;

export const TURNSTILE_SITE_KEY =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_TURNSTILE_SITE_KEY) ||
  process.env.TURNSTILE_SITE_KEY ||
  '';
export const TURNSTILE_ENABLED = !!TURNSTILE_SITE_KEY;

/**
 * Gdy `VITE_ANTIBOT_ENABLED=false`, frontend nie renderuje iframe Turnstile (apply/register),
 * ale nadal ustawia pola formularza „stubem” (zgodnie z logiką w komponencie Turnstile).
 * Domyślnie: włączone (brak zmiennej = tak jak dotąd).
 */
export const ANTIBOT_UI_ENABLED =
  typeof import.meta !== 'undefined'
    ? (import.meta as any).env?.VITE_ANTIBOT_ENABLED !== 'false'
    : true;

/** Czy faktycznie pokazać widget (iframe) — wymaga klucza + włączonego UI antybota. */
export const TURNSTILE_WIDGET_ACTIVE = TURNSTILE_ENABLED && ANTIBOT_UI_ENABLED;

/**
 * Stub pól formularza (`turnstile-disabled-local`) bez iframe — wyłącznie gdy:
 * - brak `VITE_TURNSTILE_SITE_KEY`, lub
 * - `VITE_ANTIBOT_ENABLED=false` (świadome wyłączenie UI antybota).
 * Przy normalnym local z kluczem i włączonym UI **false** — używany jest prawdziwy widget.
 */
export const TURNSTILE_FORM_STUB = !TURNSTILE_WIDGET_ACTIVE;

/** Logi / helper text przy widgetcie — nie zmienia momentu montażu Turnstile (ten sam co na produkcji). */
export const ANTIBOT_DEBUG =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_ANTIBOT_DEBUG === 'true') ||
  loadBoolEnv(process.env.ANTIBOT_DEBUG);
/**
 * Bardziej widoczny wariant iframe (appearance=always vs interaction-only) — tylko gdy widget jest już zamontowany.
 * Nie wymusza wcześniejszego pokazania widgetu (moment aktywacji ustala flow strony).
 */
export const ANTIBOT_FORCE_VISIBLE_WIDGET =
  (typeof import.meta !== 'undefined' &&
    (import.meta as any).env?.VITE_ANTIBOT_FORCE_VISIBLE_WIDGET === 'true') ||
  loadBoolEnv(process.env.ANTIBOT_FORCE_VISIBLE_WIDGET);
export const UNSUCCESSFUL_LOGIN_TRIES_HINT = 2;

export const SENTRY_DNS = process.env.SENTRY_DNS;
export const SENTRY_ENVIRONMENT = process.env.SENTRY_ENVIRONMENT;

export const FACEBOOK_APP_ID = process.env.FACEBOOK_APP_ID;

export const TESTING = loadBoolEnv(process.env.TESTING);

export const MAINTENANCE = loadBoolEnv(process.env.MAINTENANCE);

export const VERSION = version;
// Days when to show new offer label
export const NEW_OFFER_PERIOD = 3;
export const URGENT_OFFER_PERIOD = 15;

export enum SocialLink {
  Facebook = 'https://www.facebook.com/PracaNaKolach/',
}

export const SEO_DEFAULTS = {
  description:
    'Praca dla kierowców. Wszystkie oferty w jednym miejscu. Praca dla kierowców CE C B D. Jedyny polski portal pracy dla kierowców. Oferty pracy w kraju i zagranicą. Aplikuj!',
  image: `${typeof window !== 'undefined' ? window.location.origin : ''}/ogimage.png`,
  keywords: 'praca dla kierowców',
  title: 'Portal pracy dla kierowców - Praca Na Kołach',
  titleShort: 'Praca Na Kołach',
};

export const DATA_TEST_ATTRIBUTE = 'data-cy';
